var isCancel;
var hasRequiredIsCancel;

function requireIsCancel () {
	if (hasRequiredIsCancel) return isCancel;
	hasRequiredIsCancel = 1;

	isCancel = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};
	return isCancel;
}

export { requireIsCancel as __require };
//# sourceMappingURL=isCancel.js.map
